import React from "react";
import _ from "underscore";
import { Container, Row, Col } from "reactstrap";
import { joinCss } from "../helpers/utils";
import OpenFileLink from "../Components/OpenFileLink";

import appClasses from "../App.module.scss";
import classes from "./SpecificationDataTable.module.scss";

function specificationDataTable(props) {
  var toReturn = (
    <div>
      <Container className="mr-3">
        <Row className={joinCss(classes.titles, "my-4")}>
          <Col scope="col" sm="3">
            שנת מהדורה
          </Col>
          <Col scope="col" sm="5">
            קובץ מהדורה
          </Col>
          <Col scope="col" sm="4">
            קבצי דפי תיקון
          </Col>
        </Row>
        {_.map(props.editions, element => (
          <Row
            className={joinCss(
              classes.tableLine,
              "mb-2",
              "py-3",
              appClasses["vertical-center-parent"]
            )}
          >
            <Col sm="3" className={classes.editionYear}>
              מהדורה {element.year}
            </Col>
            <Col sm="5">
              <OpenFileLink
                localClass={classes.pdfLink}
                contant={element.pdfName}
                id={element.id}
                numOfLines="2"
                textLocalClass={classes.pdfName}
              />
            </Col>
            <Col sm="4">
              {_.map(element.fixes, fix => (
                <OpenFileLink
                  localClass={classes.pdfLink}
                  contant={fix.pdfName}
                  id={fix.id}
                  numOfLines="2"
                  textLocalClass={classes.pdfName}
                />
              ))}
            </Col>
          </Row>
        ))}
      </Container>
    </div>
  );

  return toReturn;
}

export default specificationDataTable;
